import React, { Component } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import { withRouter } from '../withRouter';
import styles from "components/AppView/AppNavStyles.module.scss";
import logo from '../../images/logo.png';
import userIcon from '../../images/icons/userIcon.png';
import { logout } from "actions/auth.js";

class AppNavMenu extends Component {
    static displayName = AppNavMenu.name;

    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
            showUserMenu: false,
        };
        this.wrapperRef = React.createRef();
        this.userButtonRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.showUserMenu &&
            !this.wrapperRef?.current?.contains(event.target) &&
            !this.userButtonRef?.current?.contains(event.target)) {
            this.hideUserMenu();
        }
    }

    toggleUserMenu = () => {
        this.setState({ showUserMenu: !this.state.showUserMenu });
    }

    hideUserMenu = () => {
        this.setState({ showUserMenu: false });
    }

    handleLogout = () => {
        this.props.logout();
        this.hideUserMenu();
        if (!this.props.location.pathname.includes("/play")) {
            this.props.navigate("/login");
        }
    }

    handleLogin = () => {
        this.hideUserMenu();
        this.props.navigate("/login");
    }

    handleJoin = () => {
        this.hideUserMenu();
        this.props.navigate("/join");
    }

    render() {
        const isOnJoinPage = this.props.location.pathname.includes("/join");
        const isOnLoginPage = this.props.location.pathname.includes("/login");

        return (
            <header className={`${styles.header}`}>
                <Container fluid className={styles.headerInner}>
                    <div className={`${styles.logo}`}>
                        <img src={logo} alt="" width="153" height="80"></img>
                    </div>
                    <div className={styles.actionsItem} onClick={this.toggleUserMenu} ref={this.userButtonRef}>
                        <div className={styles.userInfo}>
                            {this.props.auth.isLoggedIn && (
                                <span className={styles.userName}>
                                    {this.props.auth.user?.userName || this.props.auth.user?.email}
                                </span>
                            )}
                            <img src={userIcon} alt="" width="46" height="46" />
                        </div>
                        {this.state.showUserMenu &&
                            <ul ref={this.wrapperRef} className={styles.userMenu}>
                                {this.props.auth.isLoggedIn ? (
                                    <>
                                        <li className={styles.userNameMobile}>
                                            {this.props.auth.user?.userName || this.props.auth.user?.email}
                                        </li>
                                        <li className={styles.userMenuItem} onClick={this.handleLogout}>
                                            <span>Logout</span>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        {!isOnLoginPage && (
                                            <li className={styles.userMenuItem} onClick={this.handleLogin}>
                                                <span>Login</span>
                                            </li>
                                        )}
                                        {!isOnJoinPage && (
                                            <li className={styles.userMenuItem} onClick={this.handleJoin}>
                                                <span>Join</span>
                                            </li>
                                        )}
                                    </>
                                )}
                            </ul>
                        }
                    </div>
                </Container>
            </header>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppNavMenu));